const getNativePendingCredentialProviderFromLocalStorage = () => {
  return window.sessionStorage.getItem('native_pending_credential_provider')
}

export default getNativePendingCredentialProviderFromLocalStorage
